import { useParams } from 'react-router-dom';
import { handleInterview } from '../../../../ReduxToolkit/Reducers/LetterBoxReducer';
import { flattenEmails, updateEmailTree } from '../../../../Features/letterBox/api/emailTree';
import React, { useEffect, useState } from 'react'
import { Card, Col, TabContent, TabPane } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import DraftTab from './DraftTab';
import TrashTab from './TrashTab';
import WorkTab from './WorkTab';
import PrivateTab from './PrivateTab';
import MailHeader from './MailHeader';
import ComposeModal from './EmailModals/ComposeModal';
import AddLabelModal from './EmailModals/AddLabelModal';
import InboxTab from './InboxTab';
import EmailRead from './EmailRead';
import SentTab from './SentTab';
import StarredTab from './StarredTab';
import { RootState } from '../../../../ReduxToolkit/Store';
import { fieldEmail, letterBoxListResult } from "../../../../Features/letterBox/api/types";
import { deleteLetters, getLetterDetails } from "../../../../Features/letterBox/api/letterBox.api";

type LetterBoxNavContentType = {
  navId: string;
  listEmail: fieldEmail[] | [];
  n_pages: number | 1 ;
  isLoading: boolean
};

export default function LetterRightAside({ navId, listEmail, n_pages, isLoading }: LetterBoxNavContentType) {
    const { interviewEmail } = useSelector((state: RootState) => state.email);
    const { emailId } = useParams<{ emailId: string }>();
    const dispatch = useDispatch();
    const id = emailId?.trim() ?? '';
    const validId = id.length > 0;
    const detailQuery = useQuery({
        queryKey: ['letterBox-detail', id],
        queryFn: () => getLetterDetails(id),
        enabled: validId,
        retry: false,
    });
    const detailLoading =  detailQuery.isPending;

    const listItem = flattenEmails(listEmail).find(email => String(email.id) === id);
    const selectedDetail = detailQuery.data ? {
        ...detailQuery.data,
        data: { ...detailQuery.data.data, ticketID: detailQuery.data.data.ticketID ?? listItem?.ticketID, progettoID: detailQuery.data.data.progettoID ?? listItem?.progettoID, attivitaID: detailQuery.data.data.attivitaID ?? listItem?.attivitaID },
    } : null;
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const queryClient = useQueryClient();

    useEffect(() => { dispatch(handleInterview(Boolean(emailId))); }, [emailId, dispatch]);
    useEffect(() => {
        if (!detailQuery.data || !validId) return;
        const readId = detailQuery.data.data.ID;
        queryClient.setQueriesData<letterBoxListResult>({ queryKey: ['letterBox-list'] }, old => {
            if (!old || !flattenEmails(old.list).some(email => String(email.id) === String(readId) && email.is_read !== 1)) return old;
            return { ...old, list: updateEmailTree(old.list, readId, { is_read: 1 }) };
        });
    }, [detailQuery.data, validId, listEmail, queryClient]);

    const deleteMutation = useMutation({
        mutationFn: (ids: number[]) => deleteLetters(ids),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["letterBox-list"], exact: false });
            setSelectedIds([]);
        },
    });

    useEffect(() => {
        if (!Array.isArray(listEmail)) return;
        setSelectedIds((prev) => prev.filter((id) => flattenEmails(listEmail).some((email) => email.id === id)));
    }, [listEmail]);

    console.log(listEmail);
    
    const handleDeleteIds = (ids: number[]) => {
        if (!ids.length || deleteMutation.isPending) return;
        deleteMutation.mutate(ids);
    };

    return (
        <Col xxl={interviewEmail ? 12 : 12} xl={interviewEmail ? 12 : 12} className="box-col-12">
            <div className="email-right-aside">
                <Card className={`email-body email-list ${interviewEmail ? "hide" : "show"}`}>
                    <ComposeModal />
                    <MailHeader
                      listEmail={listEmail}
                      selectedIds={selectedIds}
                      setSelectedIds={setSelectedIds}
                      onDeleteIds={handleDeleteIds}
                      isDeleting={deleteMutation.isPending}
                    />
                    <TabContent activeTab={navId}>
                        <TabPane tabId={"1"}>
                            <InboxTab
                              listEmail={listEmail}
                              n_pages={n_pages}
                              isLoading={isLoading}
                              selectedIds={selectedIds}
                              setSelectedIds={setSelectedIds}
                              onDeleteIds={handleDeleteIds}
                            />
                        </TabPane>
                        <TabPane tabId={"2"}>
                            <SentTab />
                        </TabPane>
                        <TabPane tabId={"3"}>
                            {/* <StarredTab /> */}
                            <InboxTab
                              listEmail={listEmail}
                              n_pages={n_pages}
                              isLoading={isLoading}
                              selectedIds={selectedIds}
                              setSelectedIds={setSelectedIds}
                              onDeleteIds={handleDeleteIds}
                            />
                        </TabPane>
                        <TabPane tabId={"4"}>
                            <DraftTab />
                        </TabPane>
                        <TabPane tabId={"5"}>
                            <TrashTab listEmail = {listEmail} n_pages = {n_pages} isLoading = {isLoading} />
                        </TabPane>
                        <TabPane tabId={"6"}>
                            <WorkTab />
                        </TabPane>
                        <TabPane tabId={"7"}>
                            <PrivateTab />
                        </TabPane>
                        <TabPane tabId={"8"}>
                            <PrivateTab />
                        </TabPane>
                        <AddLabelModal />
                    </TabContent>
                </Card>
                {emailId && (!validId || detailQuery.isError) ? (
                    <div className="alert alert-danger" role="alert">Impossibile caricare il dettaglio email. <a href={`${process.env.PUBLIC_URL || ''}/gestione-email`}>Torna alla lista</a></div>
                ) : <EmailRead detail={selectedDetail} isLoadingDetail={detailLoading} />}
            </div>
        </Col >
    )
}
